import BaseSyncError from "scripts/exceptions/baseSyncError";

class UnauthorizedSyncError extends BaseSyncError {}

export default UnauthorizedSyncError;
